import invariant from 'invariant';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default (params) => {
    let { baseUrl, orderId, trackingNumber, brand, requestOptions = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of getTrackingDetails()');
    invariant(orderId, 'orderId is a required param of getTrackingDetails()');
    invariant(trackingNumber, 'trackingNumber is a required param of getTrackingDetails()');
    invariant(brand, 'brand is a required param of getTrackingDetails()');

    const url = `${baseUrl}track/brand/${brand}/orderId/${orderId}/trackingNumber/${trackingNumber}`;
    return labelRequest(authenticatedRequest(new Request(url, requestOptions), null), 'getTrackingDetails');
};
